import {z} from "zod";

export enum VCycleSide {
    LEFT = 'LEFT',
    RIGHT = 'RIGHT',
}

export const VCycleSideSchema = z.enum(VCycleSide);
